import { useRef, useEffect } from 'react';
import useGame from "../stores/useGame";

export default function SucceedMessage() {

    const showPortalRef = useRef()
    return (<>
    <div ref={showPortalRef} className={`gameover-message success-message`}>
        
        <p>CONGRATULATIONS!
        <br/>You've conquered the cosmic maze, leaving the surreal, scarlet depths behind.
        </p>
        <p>
        ABOUT THIS PROJECT
        <br/>The music you hear in the background is called a descending Shepard Tone. 
        <br/>It's an auditory illusion that makes you feel like the pitch is always dropping. 
        <br/>Like walking downwards on stairs that never end, but with music.
        </p>
        <p>
        CREDITS
        <br/>Blender assets & development by <a className={`inline`} href={"https://www.journeytojunipero.com/"}>Mirko Ruschel</a>
        <br/>Royalty free music & sound effects from <a className={`inline`} href={"https://www.pixabay.com/"}>Pixabay</a>
        <br></br>
        <br/>Special thanks to Neenara Anusin for providing wallpaper & piano assets
        <br/>and Bruno Simon for <a className={`inline`} href={"https://threejs-journey.com/"}>Three.js Journey</a>
        </p>

    </div>
    {/* <p ref={showPortalRef} className={`gameover-message success-message`}></p> */}
    </>)
}




